import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SettingsState = {
    volume: number; // Notification sound volume (0 to 1)
    mute: boolean;
    selectedAlarm: string; // Selected alarm sound file URL
    isClockwise: boolean;
    tickEnabled: boolean; // Play a tick sound every second while running
    voiceEnabled: boolean; // Speak sub-alarm labels aloud
    progressColorEnabled: boolean; // Ring shifts green→yellow→red as time runs out
    setVolume: (volume: number) => void;
    setMute: (mute: boolean) => void;
    setSelectedAlarm: (alarm: string) => void;
    setIsClockwise: (isClockwise: boolean) => void;
    setTickEnabled: (tickEnabled: boolean) => void;
    setVoiceEnabled: (voiceEnabled: boolean) => void;
    setProgressColorEnabled: (progressColorEnabled: boolean) => void;
};

export const useSettingsStore = create<SettingsState>()(
    persist(
        (set) => ({
            volume: 1,
            mute: false,
            selectedAlarm: 'kid:fanfare',
            isClockwise: true,
            tickEnabled: true,
            voiceEnabled: true,
            progressColorEnabled: true, // Default: color-by-progress on
            setVolume: (volume) => set({ volume }),
            setMute: (mute) => set({ mute }),
            setSelectedAlarm: (alarm) => set({ selectedAlarm: alarm }),
            setIsClockwise: (isClockwise) => set({ isClockwise }),
            setTickEnabled: (tickEnabled) => set({ tickEnabled }),
            setVoiceEnabled: (voiceEnabled) => set({ voiceEnabled }),
            setProgressColorEnabled: (progressColorEnabled) => set({ progressColorEnabled }),
        }),
        {
            name: 'settings-store',
            version: 6,
            migrate: (persistedState, version) => {
                const state = persistedState as SettingsState;
                if (version < 6) {
                    return {
                        ...state,
                        selectedAlarm: 'kid:fanfare',
                        isClockwise: true,
                        tickEnabled: true,
                        voiceEnabled: true,
                        progressColorEnabled: true,
                    };
                }
                return state;
            },
        }
    )
);
